var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 6V7.33333M7.99995 10H8.00662M3.38128 12.6667H12.6186C13.6453 12.6667 14.2866 11.5553 13.7733 10.6667L9.15462 2.66667C8.64128 1.778 7.35862 1.778 6.84528 2.66667L2.22662 10.6667C1.71328 11.5553 2.35462 12.6667 3.38128 12.6667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationOutline);
export default __webpack_public_path__ + "static/media/ExclamationOutline.e7b054cea4aa33d5c6258b48409107dc.svg";
export { ForwardRef as ReactComponent };